import EA from 'helpers/init';

export default EA.Methods.bannerSticky = ($this) => {
    const sticky = $this;
    const stickyClose = sticky.querySelector('.sticky-banner-zone_close');

    stickyClose.addEventListener('click', () => {
        sticky.classList.add('hidden');
    });
}